// extracted by mini-css-extract-plugin
export default {"section-loader":"section-loader_section-loader__gIe6s"};